export default "__VITE_ASSET__$cYrrOMP__"